import { Box, Text, Grid } from '@simplywallst/ui-core';

import PositiveNegativeValue from '@/components/PositiveNegativeValue';

import type { Datum } from '../../types';

import { StyledHr } from './styled';

import {
  formatterPercentage,
  formatterCurrencyTruncated,
} from '@/utilities/format';

export const HoldingBreakdown = ({ holding }: { holding?: Datum }) => {
  if (typeof holding === 'undefined') return null;
  const { label, value, currencyISO, return1y, return7d } = holding;
  return (
    <Box
      position="absolute"
      width={100}
      top="50%"
      left="50%"
      transform="translateX(-50%) translateY(-54%)"
    >
      <Text typography="smallStrong" color="brand01">
        {label}
      </Text>
      <Grid gap="1px">
        <Grid templateColumns="auto auto" justifyContent="space-between">
          <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
            Value
          </Text>
          <Text typography="tiny" color="white">
            {formatterCurrencyTruncated(value, currencyISO, 0)}
          </Text>
        </Grid>
        <StyledHr />
        <Grid templateColumns="auto auto" justifyContent="space-between">
          <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
            1Y
          </Text>
          <Text typography="tiny">
            <PositiveNegativeValue value={return1y}>
              {formatterPercentage(return1y)}
            </PositiveNegativeValue>
          </Text>
        </Grid>
        <StyledHr />
        <Grid templateColumns="auto auto" justifyContent="space-between">
          <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
            7D
          </Text>
          <Text typography="tiny">
            <PositiveNegativeValue value={return7d}>
              {formatterPercentage(return7d)}
            </PositiveNegativeValue>
          </Text>
        </Grid>
        <StyledHr />
      </Grid>
    </Box>
  );
};
